"use strict";

exports.__esModule = true;
exports.LayoutSettingsController = void 0;
var _react = require("react");
var _excluded = ["children"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var LayoutSettingsController = exports.LayoutSettingsController = /*#__PURE__*/function (_Component) {
  function LayoutSettingsController() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(LayoutSettingsController, _Component);
  var _proto = LayoutSettingsController.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return children(extra);
  };
  return LayoutSettingsController;
}(_react.Component);
LayoutSettingsController.defaultProps = {
  colorSource: {
    realtime: false,
    allowCurrentCycle: false
  },
  backgroundColorSource: {
    realtime: false,
    allowCurrentCycle: false
  },
  dataItemChart: {
    realtime: false
  },
  deviceStatus: {
    enabled: false
  },
  selection: {
    allowReportingPeriod: false
  },
  stripeChart: {
    allowSelection: false
  },
  editorSettings: {
    editMode: false
  }
};